import { render } from "./modalAnswer.vue?vue&type=template&id=d0fbe9b8&scoped=true"
import script from "./modalAnswer.vue?vue&type=script&lang=js"
export * from "./modalAnswer.vue?vue&type=script&lang=js"

import "./modalAnswer.vue?vue&type=style&index=0&id=d0fbe9b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d0fbe9b8"

export default script